"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ABR_BITRATES = exports.ABR_STRATEGY = void 0;
var ABR_STRATEGY;
(function (ABR_STRATEGY) {
    ABR_STRATEGY["PERFORMANCE"] = "performance";
    ABR_STRATEGY["QUALITY"] = "quality";
    ABR_STRATEGY["BANDWIDTH"] = "bandwidth";
})(ABR_STRATEGY || (exports.ABR_STRATEGY = ABR_STRATEGY = {}));
exports.ABR_BITRATES = (_a = {},
    _a[ABR_STRATEGY.BANDWIDTH] = undefined,
    _a[ABR_STRATEGY.PERFORMANCE] = 0,
    _a[ABR_STRATEGY.QUALITY] = 10000000,
    _a);
//# sourceMappingURL=abr.js.map